import React, { useState } from 'react';

export default function BookmarkButton({
  isBookmarked, onToggle, sceneId, tutorialId, domain,
  style = {},
}) {
  const [loading, setLoading] = useState(false);

  const handleClick = async (e) => {
    e.stopPropagation();
    setLoading(true);
    try {
      await onToggle({
        scene_id: sceneId,
        tutorial_id: tutorialId,
        domain,
        note_type: 'bookmark',
        text: 'Bookmarked',
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      onClick={handleClick}
      disabled={loading}
      title={isBookmarked ? 'Remove bookmark' : 'Bookmark this segment'}
      style={{
        background: 'none', border: 'none', cursor: 'pointer',
        fontSize: '1.1rem', padding: '4px 6px', opacity: loading ? 0.5 : 1,
        transition: 'transform 0.15s',
        ...style,
      }}
      onMouseEnter={(e) => { e.currentTarget.style.transform = 'scale(1.2)'; }}
      onMouseLeave={(e) => { e.currentTarget.style.transform = 'scale(1)'; }}
    >
      {isBookmarked ? '★' : '☆'}
    </button>
  );
}
